<template>
    <el-select
        class="select-poi"
        v-model="values"
        :placeholder="placeholder"
        :multiple="cMultiple"
        :disabled="disabled"
        :clearable="clearable"
        :filterable="filterable"
        :size="size"
        v-bind="$attrs"
    >
        <el-option v-for="poi in poiList" :label="poi.name" :key="poi.poiId" :value="getInnerKeyValue(poi)" :disabled="poi.disabled"></el-option>
    </el-select>
</template>

<script>
/**
 * @author mengqinghui
 * 门店下拉框，常见的业务场景
 *  1. 门店下拉框
 */

import { POI_TYPE } from '../../utils/enum';
import { getRequestHost } from '../../utils/constants';

export default {
    name: 'XxPoiSelect',
    props: {
        /**
         * @model
         */

        value: {
            type: [Object, Array, String],
            default: ''
        },
        /**
         * 是否带权限，默认是false
         */
        usePermission: {
            required: true,
            default: false
        },
        /**
         * size 同el-select
         */
        size: {
            default: () => {
                return 'small';
            }
        },
        /**
         * 列表中可展示的门店类型
         * POI: 0, DC: 1, RDC: 2, FDC: 3
         */
        poiTypes: {
            type: Array,
            default: () => {
                return [POI_TYPE.POI, POI_TYPE.DC, POI_TYPE.RDC, POI_TYPE.FDC];
            }
        },
        /**
         * 被选中的值
         */
        selectItems: [Object, Array, String, Number],
        /**
         * placeholder
         */
        placeholder: {
            type: String,
            default: '请选择门店'
        },
        /**
         * ajax相关的，如果是string，就认为是一个url
         */
        fetchOpt: [Object, String],
        /**
         * 是否显示dc 仓，默认是false,  默认不需要显示dc
         */
        needDC: Boolean, // 请求的参数是否需要仓储， 这个为了兼容旧的版本，先不放在fetchOpt里面了
        /**
         * 是否被禁用 同el-select
         */
        disabled: Boolean, // 是否禁用
        /**
         * 是否可清空 同el-select
         */
        clearable: {
            type: Boolean,
            default: true
        },
        /**
         * 是否可过滤 同el-select
         */
        filterable: {
            type: Boolean,
            default: true
        },
        /**
         * 获取单条的值，默认是item.poiId
         */
        getKeyValue: Function,
        /**
         * 是否支持单选，默认是false
         */
        multiple: Boolean,
        /**
         * 对返回数据进一步处理
         */
        processData: Function,
        /**
         * 是否默认选中第一个，默认是false
         */
        selectFirst: {
            type: Boolean,
            default: false
        },
        /**
         * 业态选择  1-生鲜，2-菜店 0所有
         */
        bizId: {
            type: Number,
            default: 0
        },
        /**
         * 知了报表接口专门新的参数，用于解决配送骑手数据权限。
         * 60：芥末组织的数据权限+配送合作商的数据权限
         * 缺省：芥末组织的数据权限
         */
        orgId: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            POI_TYPE,
            resList: [],
            poiList: []
        };
    },
    watch: {
        bizId() {
            this.getPoiList();
        }
    },
    computed: {
        values: {
            get: function() {
                return this._getSelectedItemValues(this.value || this.selectItems);
            },
            set: function(nVal) {
                this.change(nVal);
            }
        },
        cMultiple: function() {
            return Array.isArray(this.value || this.selectItems) ? true : this.multiple;
        }
    },
    created() {
        this.getPoiList();
    },

    methods: {
        input(value) {
            this.$emit('input', value);
        },
        change(value) {
            let getPoiByValue = value => {
                return this.poiList.find(item => {
                    return this.getInnerKeyValue(item) === value;
                });
            };
            let items = '';
            if (this.cMultiple) {
                items = value.map(item => {
                    return getPoiByValue(item);
                });
            } else {
                items = getPoiByValue(value);
            }

            this.$emit('input', value);
            /**
             * 切换门店的时候触发 (value, items)
             *
             * @event change
             * @type {value}
             */
            this.$emit('change', value, items);

            return this.value || this.selectItems;
        },
        _getSelectedItemValues(selectItems) {
            if (this.cMultiple) {
                // 多选的时候
                selectItems = selectItems ? (Array.isArray(selectItems) ? selectItems : [selectItems]) : [];
                return selectItems.map(poi => {
                    if (typeof poi === 'string') {
                        poi = {
                            poiId: poi
                        };
                    }
                    return this.getInnerKeyValue(poi);
                });
            }
            return this.getInnerKeyValue(selectItems);
        },

        getPoiList() {
            let url = this.usePermission ? '/api/auth/org/getRegionAndPoiModelMapWithPermission' : '/api/auth/org/getRegionAndPoiModelMap';
            let params = {
                needRdc: this.needDC ? 0 : 1,
                bizId: this.bizId,
            };
            if (this.orgId) {
                params.orgId = this.orgId;
            }
            let fetchOpt = this.fetchOpt || {
                url: `${getRequestHost()}${url}`,
                body: params
            };
            if (typeof fetchOpt === 'string') {
                fetchOpt = { url: fetchOpt };
            }
            let { body, ...options } = fetchOpt;
            let processData =
                this.processData ||
                function(data) {
                    return data;
                };

            this.$get(fetchOpt.url, body, options)
                .then(data => {
                    let list = (data.regionAndPOiList || []).filter(poi => poi.poiBizId !== 4 && this.poiTypes.includes(+poi.poiType)).map(item => {
                        return {
                            ...item,
                            bizId: `${item.poiBizId}`,
                            poiId: `${item.poiId}`,
                            name: item.poiName
                        };
                    });
                    this.poiList = processData(list);
                    this.resList = processData(list);
                    if (this.selectFirst) {
                        const value = this._getSelectedItemValues(this.poiList[0] && this.poiList[0].poiId);
                        this.change(value);
                    }
                    /**
                     * 当请求数据完成时触发 (poiList)
                     *
                     * @event loaded
                     * @type {Array}
                     */
                    this.$emit('loaded', this.poiList);
                })
                .catch(err => {
                    this.$message({
                        type: 'error',
                        message: err.message || '获取门店列表失败'
                    });
                });
        },

        getInnerKeyValue(poi) {
            let getKeyValue =
                this.getKeyValue ||
                (poi => {
                    if (typeof poi === 'string') {
                        return poi;
                    }
                    return poi && poi.poiId;
                });
            return getKeyValue(poi);
        },
        resetOption(filter) {
            this.$set(this, 'poiList', filter(this.resList));
        },
        /**
         * 修改门店列表数据
         *
         * @param filter: 处理门店数据的函数
         * @param param: filter函数的参数 可选
         */
        changePoiOption(filter, param) {
            this.$set(this, 'poiList', filter(this.poiList, param));
        }
    }
};
</script>
